import request from 'assets/js/http';

export function menuList() {
  // 获取菜单列表
  return request({
    url: '/project/menu/list',
    method: 'post'
  });
}
export function menuDelete(data) {
  // 菜单路由-删除
  return request({
    url: '/project/menu/delete',
    method: 'post',
    data
  });
}
export function menuAction(data) {
  // 菜单路由-添加
  let url = '/project/menu/add';
  if (data.id || data.id === 0) {
    url = '/project/menu/edit';
  }
  return request({
    url: url,
    method: 'post',
    data
  });
}
